function resizeToFit(el) {
  const parent = el.parentElement;
  if (!parent) return;

  const style = window.getComputedStyle(el);
  const maxFontSize = parseFloat(style.getPropertyValue('--fit-text-max') || style.fontSize);
  const minFontSize = parseFloat(style.getPropertyValue('--fit-text-min') || '12');

  let fontSize = maxFontSize;
  el.style.fontSize = maxFontSize + 'px';

  let guard = 0;

  while (el.scrollWidth > parent.clientWidth && fontSize > minFontSize && guard < 30) {
    fontSize -= 1;
    el.style.fontSize = fontSize + 'px';
    guard++;
  }
}

export default {
  mounted(el) {
    resizeToFit(el);

    const onResize = () => resizeToFit(el);
    window.addEventListener('resize', onResize);

    el.__fitTextResize__ = onResize;
  },
  updated(el) {
    resizeToFit(el);
  },
  unmounted(el) {
    const onResize = el.__fitTextResize__;
    if (onResize) {
      window.removeEventListener('resize', onResize);
      delete el.__fitTextResize__;
    }
  },
};
